
import { valueForKeyPath } from 'key.path'
// ///////////////////////////////////////////////////////
import { filterEmpty } from './utils'
// ///////////////////////////////////////////////////////
const defaultRadius = {
  default: 3
}
// ///////////////////////////////////////////////////////
export const composeBorderRadiuStyle = props => {
  const radii = valueForKeyPath('theme.radius', props) || defaultRadius
  const borderRadius = props.radius ? radii[props.radius] : null
  return filterEmpty({ borderRadius })
}
